<template>
  <v-card outlined rounded="lg" class="pa-4" elevation="0">
    <v-row class="ma-0" v-if="!isResult">
      <v-col class="text-center" cols="12">
        <span>{{ $t('Período') }}</span>
        <div class="d-flex justify-center align-center mt-3">
          <v-menu
            ref="startDateMenu"
            :close-on-content-click="false"
            :return-value.sync="startDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                :disabled="isResult"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(startDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="startDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.startDateMenu.save(startDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>

          <span class="mx-2">{{ $t('Até') }}</span>

          <v-menu
            ref="endDateMenu"
            :close-on-content-click="false"
            :return-value.sync="endDate"
            transition="scale-transition"
            @change="list"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                readonly
                :disabled="isResult"
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(endDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="endDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.endDateMenu.save(endDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <v-col cols="12">
        <v-divider class="my-4"></v-divider>
      </v-col>
    </v-row>

    <v-alert
      type="warning"
      class="my-3 pa-1 text-center"
      v-if="equips.length == 0"
    >
      {{ $t('Nenhum equipamento encontrado') }}
    </v-alert>

    <div v-else>
      <v-row class="ma-0" justify="center">
        <v-col cols="12">
          <HorizontalBarChart
            :chart-data="chartData"
            :options="options"
            :key="chartKey"
          />

          <div>
            <div class="hidden-md-and-up">
              <v-data-table
                :loading="loading"
                :headers="headerMobile"
                :items="equips"
                class="main-table"
                hide-default-footer
                show-expand
                item-key="standardEquipmentName"
                :single-expand="false"
                :items-per-page="5"
                :header-props="headerProps"
                :mobile-breakpoint="330"
                :expanded.sync="expanded"
                @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
              >
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Erro operacional') }}:</strong>
                        {{ item.quantityOperationalError }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Abuso na utilização') }}:</strong>
                        {{ item.quantityAbuseInUse }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Dano acidental') }}:</strong>
                        {{ item.quantityAccidentalDamage }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Falha intrínseca') }}:</strong>
                        {{ item.quantityIntrinsicFailure }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Não aplicável') }}:</strong>
                        {{ item.quantityNotApplicable }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Falha infraestrutura') }}:</strong>
                        {{ item.quantityInfrastructureFailure }}
                      </p>
                    </v-col>
                  </td>
                </template>
              </v-data-table>
            </div>

            <div class="hidden-md-and-down">
              <v-data-table
                :loading="loading"
                :headers="header"
                :items="equips"
                class="main-table"
                hide-default-footer
                hide-default-header
                :header-props="headerProps"
                :items-per-page="5"
                :mobile-breakpoint="0"
              >
                <template #header="{ props, on }">
                  <thead>
                    <tr>
                      <th
                        class="text-center"
                        v-for="header in props.headers"
                        :key="header.value"
                      >
                        <v-simple-checkbox
                          v-if="header.value === 'data-table-select'"
                          v-model="props.everyItem"
                          :indeterminate="props.someItems && !props.everyItem"
                          color="purple"
                          @input="on['toggle-select-all']"
                        ></v-simple-checkbox>

                        <div>
                          <v-hover v-slot="{ hover }">
                            <div>
                              <span>{{ $t(header.text) }}</span>
                              <v-icon
                                v-if="
                                  hover &&
                                  header.value != 'data-table-select' &&
                                  header.value != 'actions'
                                "
                                color="white"
                                class="mx-2"
                                @click="on.sort(header.value)"
                              >
                                {{
                                  props.options.sortBy.includes(header.value)
                                    ? `mdi-chevron-down`
                                    : `mdi-chevron-up`
                                }}
                              </v-icon>
                            </div>
                          </v-hover>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else>
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../../../services/ApiService'
import HorizontalBarChart from '../../../../charts/horizontalBarChart'
import moment from 'moment'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  props: {
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  components: {
    HorizontalBarChart,
    TiptapVuetify,
  },

  async created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.filter.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.filter.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  data: () => ({
    chartKey: false,
    startDate: null,
    endDate: null,
    extensions: [
      History,
      Blockquote,
      Link,
      Underline,
      Strike,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [
        Heading,
        {
          options: {
            levels: [1, 2, 3],
          },
        },
      ],
      Bold,
      Code,
      HorizontalRule,
      Paragraph,
      HardBreak,
    ],
    filter: {
      page: 1,
      pageSize: 7,
      review: '',
    },
    loading: false,
    showChart: true,
    page: 1,
    totalPages: 1,
    pageSize: 7,
    expanded: [],
    equipmentName: [],
    legends: [],
    failuresQuantity: [],
    quantityAbuseInUse: [],
    quantityAccidentalDamage: [],
    quantityInfrastructureFailure: [],
    quantityIntrinsicFailure: [],
    quantityOperationalError: [],
    quantityNotApplicable: [],
    equips: [],
    chartData: {},
    options: {},
    filter: {},
    header: [
      {
        text: '',
        align: 'left',
        value: '',
      },
      {
        text: 'Equipamento Padrão',
        align: 'left',
        value: 'standardEquipmentName',
      },
      {
        text: 'Total',
        align: 'center',
        value: 'totalFailures',
      },
      {
        text: 'Erro Operacional',
        align: 'center',
        value: 'quantityOperationalError',
      },
      {
        text: 'Abuso na Utilização',
        align: 'center',
        value: 'quantityAbuseInUse',
      },
      {
        text: 'Dano Acidental',
        align: 'center',
        value: 'quantityAccidentalDamage',
      },
      {
        text: 'Falha Intríseca',
        align: 'center',
        value: 'quantityIntrinsicFailure',
      },
      {
        text: 'Falha Infraestrutura',
        align: 'center',
        value: 'quantityInfrastructureFailure',
      },
      {
        text: 'Não Aplicável',
        align: 'center',
        value: 'quantityNotApplicable',
      },
    ],
    headerMobile: [
      {
        text: 'Equipamento Padrão',
        align: 'left',
        value: 'name',
      },
      {
        text: 'Total',
        align: 'center',
        value: 'total',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    total: 0,
  }),

  methods: {
    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: '1.5 - Top 5 equipamentos com mais falhas',
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    fillEquips() {
      this.chartData = {
        labels: this.equipmentName,
        datasets: [
          {
            label: this.$t('Erro operacional'),
            data: this.quantityOperationalError,
            backgroundColor: '#426483',
          },
          {
            label: this.$t('Abuso na utilização'),
            data: this.quantityAbuseInUse,
            backgroundColor: '#BBCF20',
          },
          {
            label: this.$t('Dano acidental'),
            data: this.quantityAccidentalDamage,
            backgroundColor: '#0F3565',
          },
          {
            label: this.$t('Falha intrínseca'),
            data: this.quantityIntrinsicFailure,
            backgroundColor: '#212950',
          },
          {
            label: this.$t('Não aplicável'),
            data: this.quantityNotApplicable,
            backgroundColor: '#C4E8F2',
          },
          {
            label: this.$t('Falha infraestrutura'),
            data: this.quantityInfrastructureFailure,
            backgroundColor: '#ED8990',
          },
        ],
      }

      setTimeout(() => {
        this.chartKey = !this.chartKey
      }, 500)
    },

    fillOptions() {
      this.options = {
        maintainAspectRatio: false,
        responsive: true,
        barPercentage: 0.5,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
            },
          ],
        },
        legend: {
          display: true,
          responsive: false,
          maintainAspectRatio: false,
          position: 'right',
          labels: {
            usePointStyle: true,
          },
        },
      }
    },

    async list() {
      if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.total = response.content.pager.totalItems
        this.equipmentName = []
        this.quantityAbuseInUse = []
        this.quantityAccidentalDamage = []
        this.quantityInfrastructureFailure = []
        this.quantityIntrinsicFailure = []
        this.quantityNotApplicable = []
        this.quantityOperationalError = []
        this.equips = response.content.objects

        this.totalPages = response.content.pager.totalPages
        this.showChart = response.content.objects.length > 0

        response.content.objects.map((obj) => {
          this.equipmentName.push(obj.standardEquipmentName)
          this.quantityAbuseInUse.push(obj.quantityAbuseInUse)
          this.quantityAccidentalDamage.push(obj.quantityAccidentalDamage)
          this.quantityInfrastructureFailure.push(
            obj.quantityInfrastructureFailure
          )
          this.quantityIntrinsicFailure.push(obj.quantityIntrinsicFailure)
          this.quantityNotApplicable.push(obj.quantityNotApplicable)
          this.quantityOperationalError.push(obj.quantityOperationalError)
        })

        this.fillEquips()
        this.fillOptions()
        return
      }

      this.setDates()
      this.filter.institutionId = this.institution.id
      this.filter.pageSize = 7
      this.filter.unidadeIds = this.unidades
      await this.apiService
        .post('reports/topFiveFailures', this.filter)
        .then((response) => {
          this.total = response.content.pager.totalItems
          this.equipmentName = []
          this.quantityAbuseInUse = []
          this.quantityAccidentalDamage = []
          this.quantityInfrastructureFailure = []
          this.quantityIntrinsicFailure = []
          this.quantityNotApplicable = []
          this.quantityOperationalError = []
          this.equips = response.content.objects

          this.totalPages = response.content.pager.totalPages
          this.showChart = response.content.objects.length > 0

          response.content.objects.map((obj) => {
            this.equipmentName.push(obj.standardEquipmentName)
            this.quantityAbuseInUse.push(obj.quantityAbuseInUse)
            this.quantityAccidentalDamage.push(obj.quantityAccidentalDamage)
            this.quantityInfrastructureFailure.push(
              obj.quantityInfrastructureFailure
            )
            this.quantityIntrinsicFailure.push(obj.quantityIntrinsicFailure)
            this.quantityNotApplicable.push(obj.quantityNotApplicable)
            this.quantityOperationalError.push(obj.quantityOperationalError)
          })
        })
        .catch((err) => {})

      this.fillEquips()
      this.fillOptions()
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
